import { useEffect, useRef, useState } from "react";
import { DownloadCloud, Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { NUM } from "@/lib/format";

/** Tüm gelen faturalar (onaylı / onaysız) otomatik taranır; seçili tedarikçi önce. İlerleme gösterilir, bitince arama yenilenir. */
export function ScanBanner({ open, vkn, onDone }) {
  const [st, setSt] = useState(null);
  const wasRunning = useRef(false);

  const apply = (d) => {
    setSt(d);
    if (wasRunning.current && (!d.running || (vkn && d.vkn_left === 0))) onDone();
    wasRunning.current = !!d.running && !(vkn && d.vkn_left === 0);
  };
  // Açılışta ve tedarikçi değişince: tarama başlat / öncelik ver
  useEffect(() => {
    if (!open) return;
    wasRunning.current = false;
    api.post("/qnb/returns/scan", { vkn: vkn || "" }).then((r) => { wasRunning.current = !!r.data.running; setSt(r.data); }).catch(() => {});
  }, [open, vkn]);
  useEffect(() => {
    if (!open || !st?.running) return undefined;
    const t = setInterval(() => {
      api.get("/qnb/returns/scan-status", { params: { vkn: vkn || undefined } }).then((r) => apply(r.data)).catch(() => {});
    }, 2500);
    return () => clearInterval(t);
  }, [open, st?.running, vkn]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!st) return null;
  if (!st.running && !st.all_left) {
    return (
      <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs text-emerald-900 flex items-center gap-2" data-testid="ret-scan-done">
        <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0" />Tedarikçilerden gelen bütün alış faturaları (onaylı / onaysız) tarandı — arama hepsini kapsıyor.
      </div>
    );
  }
  if (!st.running) {
    return (
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs text-amber-900 flex items-center gap-2" data-testid="ret-scan-stopped">
        <AlertTriangle className="h-4 w-4 text-amber-600 shrink-0" />{NUM(st.all_left)} faturanın kalemleri QNB'den alınamadı{st.last_error ? ` (${st.last_error})` : ""} — sistem 15 dakikada bir tekrar dener.
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 px-3 py-1.5 text-xs text-sky-950 flex items-center gap-2 flex-wrap" data-testid="ret-scan-banner">
      <DownloadCloud className="h-4 w-4 text-sky-600 shrink-0" />
      <span className="flex-1">
        Tüm alış faturaları otomatik taranıyor… <b className="tabular-nums" data-testid="ret-scan-progress">{NUM(st.done)} / {NUM(st.total || st.all_left)}</b>
        {vkn ? (st.vkn_left ? <> · bu tedarikçide kalan <b className="tabular-nums">{NUM(st.vkn_left)}</b> (önce bunlar taranıyor)</> : <> · <b className="text-emerald-700">bu tedarikçinin tüm faturaları tarandı</b></>) : null}
      </span>
      <Loader2 className="h-4 w-4 animate-spin text-sky-600" />
    </div>
  );
}
